import { render, staticRenderFns } from "./ZeroCollector.vue?vue&type=template&id=007f2e68&scoped=true"
import script from "./ZeroCollector.vue?vue&type=script&lang=js"
export * from "./ZeroCollector.vue?vue&type=script&lang=js"
import style0 from "./ZeroCollector.vue?vue&type=style&index=0&id=007f2e68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f2e68",
  null
  
)

export default component.exports